import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_DATA,
  REQUEST_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  fetchingData: {},
  data: [],
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION:
      return setDefinitionToState(state, action.idx, action.definition);

    case DELETE_COLUMN:
      return removeDefinitionFromState(state, action.payload);

    case SET_DEFINITIONS:
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;

    case COMMIT_SELECTIONS: {
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_DATA:
      state.fetchingData = true;
      state.data = defaultState.data;
      break;

    case RECEIVE_DATA:
      state.fetchingData = false;
      state.data = action.data;
      break;

    default:
      return state;
  }
});
export default reducer;
